import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getOperationCashFlow } from "../../../../services/finance/financeReportService";
import Illustration from "../../../../partials/content/Illustration";
import { formatDate } from "../../../../utils/utils";
const operationCashFlowItemsColumns = [
  {
    header: "Document Ref",
    field: "documentRef",
    body: null,
    sortable: true,
    filter: true,
  },
  {
    header: "Posting Date",
    field: "postingDate",
    body: (rowData) => formatDate(rowData.postingDate),
    sortable: true,
    filter: true,
  },
  {
    header: "Vendor Name",
    field: "vendorName",
    body: null,
    sortable: true,
    filter: true,
  },
  {
    header: "Amount",
    field: "amount",
    body: (rowData) => (
      <NumberFormat
        value={rowData.amount}
        displayType={"text"}
        thousandSeparator={true}
        decimalScale={2}
        renderText={(value) => (
          <div className="float-right">
            {rowData.currencyCode} {value}
          </div>
        )}
      />
    ),
  },
];
function OperationCashFlow() {
  const [operationCashFlow, setOperationCashFlow] = useState([]);
  const { reload } = useGlobalData();
  useEffect(() => {
    getOperationCashFlowData();
  }, [reload]);
  async function getOperationCashFlowData() {
    const response = await getOperationCashFlow();
    const { data } = response.data;
    setOperationCashFlow(data.operationCashFlow);
  }
  return (
    <React.Fragment>
      <CustomDataTable
        data={operationCashFlow}
        dataDetailTitle="Operation Cost & Revenue"
        dataDetailName="operationCashFlowItems"
        dataDetailColumns={operationCashFlowItemsColumns}
        onRefreshData={() => {
          getOperationCashFlowData();
        }}
        columns={[
          {
            header: "Operation ID",
            field: "operationCardID",
            body: null,
            sortable: true,
            filter: true,
          },
          {
            header: "Operation Title",
            field: "operationCardTitle",
            body: null,
            sortable: true,
            filter: true,
          },
          {
            header: "Item Name",
            field: "itemName",
            body: null,
            sortable: true,
            filter: true,
          },
          {
            header: "Batch Code",
            field: "batchCode",
            body: null,
            sortable: true,
            filter: true,
          },
          {
            header: "Total Return Amount",
            field: "totalReturnAmount",
            body: (rowData) => (
              <NumberFormat
                value={rowData.totalReturnAmount}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                renderText={(value) => (
                  <div className="float-right">
                    {rowData.currencyCode} {value}
                  </div>
                )}
              />
            ),
            sortable: true,
            filter: true,
          },
        ]}
      />
    </React.Fragment>
  );
}

export default OperationCashFlow;
